import React, { useState } from "react";

import {
  Button,
  CircularProgress,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import DialogCommon from "../../../../components/dialogs/DialogCommon";
import { AxiosError } from "axios";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import { Autocomplete } from "@material-ui/lab";
import { CustomTheme } from "../../../../types/customTheme";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_highlight_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
    errorText: {
      color: theme.palette.error.main,
      marginTop: "8px",
      fontSize: "0.75rem",
    },
  }),
);

export interface ManageAppsProps {
  isLoading: any;
  setOpenDialog: any;
  openDialog: any;
  handleCreateIntegration: any;
  existingTypes: any[]; // New prop to check existing types
}

const customerRoles = [
  { id: "hubrise", label: "Hubrise" },
  //   { id: "deliverect", label: "Deliverect" },
  //   { id: "uber-eats", label: "Uber Eats" },
];

const IntegrationCreateModal: React.FunctionComponent<ManageAppsProps> = ({
  isLoading,
  setOpenDialog,
  openDialog,
  handleCreateIntegration,
  existingTypes = [],
}) => {
  const [selectedIntegration, setSelectedIntegration] = useState<any>({
    id: "hubrise",
    label: "Hubrise",
  });
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const handleChangeIntegration = (e: any, role: any) => {
    setSelectedIntegration(role);
    setError(""); // Clear error when selection changes
  };

  const handleCreate = () => {
    // Check if the selected integration type already exists
    // const typeExists = existingTypes.some(
    //   (type) => type.toLowerCase() === selectedIntegration.id.toLowerCase()
    // );

    // if (typeExists) {
    //   setError(
    //     `"${selectedIntegration.label}" integration already exists. Cannot create duplicate type.`
    //   );
    //   return;
    // }

    // No error, proceed with creation
    handleCreateIntegration(selectedIntegration.id);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setError(""); // Clear error when dialog closes
  };

  const classes = useStyles();
  const theme: CustomTheme = useTheme();

  return (
    <DialogCommonDefault
      open={openDialog}
      setOpen={handleClose}
      isNeedFixedHeight={false}
      backgroundColor={theme.palette.background.entity_background}
      maxWidth={"sm"}
    >
      <DialogTitle>Create New Integration</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <Autocomplete
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              size={"small"}
              id="integrationTypeSelect"
              color="inherit"
              options={customerRoles}
              value={selectedIntegration}
              getOptionLabel={(option: any) => option.label || ""}
              disableClearable
              onChange={handleChangeIntegration}
              classes={{ root: classes.autoComplete }}
              popupIcon={<ArrowDropDownIcon color={"inherit"} />}
              renderOption={(props: any) => {
                return (
                  <Grid
                    container
                    {...props}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      zIndex: 0,
                      height: "20px",
                      marginBottom: "4px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.titleColor}
                      >
                        {props.label}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  color="inherit"
                  {...params}
                  label=""
                  placeholder="Select Integration Type"
                  variant="outlined"
                  error={!!error}
                />
              )}
            />
            {error && (
              <Typography variant="body2" className={classes.errorText}>
                {error}
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <ButtonCommon
          onClick={handleClose}
          color="yellow"
          style={{ marginRight: "12px" }}
        >
          Cancel
        </ButtonCommon>
        <ButtonCommon
          onClick={handleCreate}
          color="green"
          autoFocus
          style={{ marginRight: "12px" }}
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Create"
          )}
        </ButtonCommon>
      </DialogActions>
    </DialogCommonDefault>
  );
};

export default IntegrationCreateModal;
